import * as React from "react";
import DatePicker from "react-datepicker";

export const DateRange = ({
  monthSelectedStart,
  setMonthSelectedStart,
  monthSelectedEnd,
  setMonthSelectedEnd,
}) => {
  return (
    <>
      <DatePicker
        selected={monthSelectedStart}
        selectsStart
        startDate={monthSelectedStart}
        endDate={monthSelectedEnd}
        dateFormat="MM/yyyy"
        showMonthYearPicker
        className={"react-datepicker-smaller"}
        onChange={selected => setMonthSelectedStart(selected)}
      />
      <DatePicker
        selected={monthSelectedEnd}
        selectsEnd
        startDate={monthSelectedStart}
        endDate={monthSelectedEnd}
        dateFormat="MM/yyyy"
        showMonthYearPicker
        className={"react-datepicker-smaller"}
        onChange={selected => setMonthSelectedEnd(selected)}
      />
    </>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/DateRange.tsx